import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';

/**
 * Desktop keep-awake rollout and kill switch. PostHog, default OFF: an
 * unresolved or missing flag reads as off, so the native wake assertion stays
 * released. Rollout gate, not an experiment — do not add useManualExposure.
 */
export const CUA_WAKE_ASSERTION_FLAG_KEY = 'release-apps-cua-wake-assertion-desktop';

export const useIsCuaWakeAssertionEnabled = (): boolean =>
  useFeatureFlagEnabled(CUA_WAKE_ASSERTION_FLAG_KEY) ?? false;
